"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shades = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Shades = ({
  shades,
  maxVisible
}) => {
  const shadesToRender = (0, _react.useMemo)(() => shades.slice(0, maxVisible).map(shade => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Shade, {
    shade: shade,
    size: _presentationComponents.ShadeSize.Small,
    testId: _constants.SEARCH_SHADE
  }, shade.productCode)), [shades, maxVisible]);
  if (shades.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [shadesToRender, shades.length > maxVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      color: "textPrimary",
      variant: "overline",
      fontWeight: "bold",
      lineHeight: "normal",
      children: ["+", shades.length - maxVisible]
    }) : null]
  });
};
exports.Shades = Shades;
